<template>

  <div class="skycard" ref="cardBase" :style="{backgroundImage: backgroundImage}">
    <div class="avatar">
      <img :src="avatarDataUrl" alt="Avatar" v-if="avatarDataUrl" @click="promptFile()">
      <div class="avatar-upload" @click="promptFile()" v-if="!avatarDataUrl">
        <Trans>
          <template v-slot:en>
            Click to select picture
          </template>
          <template v-slot:jp>
            クリックして画像を選択します
          </template>
        </Trans>
      </div>
      <input type="file" hidden ref="file" @change="loadFile()">
      <input type="file" hidden ref="backgroundFile" @change="loadBackgroundFile()">
    </div>
    <div class="name">
      <h3 class="nickname" contenteditable="true" onclick="document.execCommand('selectAll',false,null)">
        E.g Lucent
      </h3>
      <h4 class="title" contenteditable="true" onclick="document.execCommand('selectAll',false,null)">
        E.g Hi, I'm a wandering pianist!
      </h4>
    </div>
    <div class="about">
      <div class="left">
        <AboutEntry label-en="About" label-jp="約" class="entry" value="E.g Hi, I am Lucent ^^"></AboutEntry>
        <AboutEntry label-en="Played Since" label-jp="以来プレイ" class="entry" value="E.g August 2019"></AboutEntry>
        <AboutEntry label-en="Language" label-jp="言語" class="entry" value="E.g English, a bit of Japanese"></AboutEntry>
      </div>
      <div class="right">
        <div class="online-toggles">
          <OnlineToggles></OnlineToggles>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Trans from '../../components/text/Trans'
import Toggle from '../../components/toggle/Toggle'
import OnlineToggles from './OnlineToggles'
import AboutEntry from './AboutEntry'

export default {
  name: 'Skycard',
  components: {AboutEntry, OnlineToggles, Toggle, Trans},
  data() {
    return {
      avatarDataUrl: null,
      language: 'English and a bit of Japanese',
      activeBackground: 1,
      customBackground: null
    }
  },
  computed: {
    backgroundImage() {
      if (this.customBackground) {
        return `linear-gradient(to bottom, #ecea, #effa), url('${this.customBackground}')`
      }
      return `linear-gradient(to bottom, #ecea, #effa), url('background/${this.activeBackground}.png')`
    },
  },
  methods: {
    uploadBackground() {
      this.$refs.backgroundFile.click()
    },
    loadBackgroundFile() {
      const files = this.$refs.backgroundFile.files
      if (!files || files.length !== 1) {
        return
      }
      const reader = new FileReader()
      reader.addEventListener('loadend', () => {
        this.customBackground = reader.result
      })
      reader.readAsDataURL(files[0])
    },
    cycleBackground() {
      this.customBackground = null
      this.activeBackground++
      if (this.activeBackground >= 6) {
        this.activeBackground = 1
      }
    },
    promptFile() {
      this.$refs.file.click()
    },
    loadFile() {
      const files = this.$refs.file.files
      if (!files || files.length !== 1) {
        return
      }
      const reader = new FileReader()
      reader.addEventListener('loadend', () => {
        this.avatarDataUrl = reader.result
      })
      reader.readAsDataURL(files[0])
    }
  }
}
</script>

<style scoped>
.skycard {
  background-size: cover;
  border: solid 1px #aaa;
  border-radius: 4px;
}

.avatar {
  margin: 32px 32px 0;
  text-align: center;
}

.avatar img {
  height: 224px;
  width: 224px;
  margin: auto;
  border-radius: 4px;
  object-fit: cover;
}

.avatar-upload {
  border-radius: 4px;
  margin: auto;
  width: 224px;
  height: 224px;
  justify-content: center;
  display: flex;
  align-items: center;
  background: #eee;
  padding: 32px;
  box-sizing: border-box;
}

.name {
  margin-top: 8px;
  text-align: center;
  padding: 0 16px;
}

.nickname, .title {
  margin: 0;
  padding: 0;
}

.nickname {
  font-size: 16px;
  font-weight: 700;
}

.title {
  font-size: 14px;
  font-weight: 700;
  opacity: 0.75;
}

.online-toggles {
  text-align: center;
}

.about {
  margin: 16px 0 32px 0;
  padding: 0 32px;
  display: flex;
  align-items: center;
}

.about .left {
  flex: 1 1 auto;
}

.about .right {
  flex: 0 0 auto;
  margin-left: 16px;
  width: 48px;
}

.about .entry {
  margin-bottom: 8px;
}


</style>
